import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchStats = () => axios.get(`${API}/ecosystem/stats`).then((r) => r.data);
export const fetchBasket = () => axios.get(`${API}/basket`).then((r) => r.data);
export const fetchTransparency = () => axios.get(`${API}/transparency`).then((r) => r.data);
export const checkRewards = (address) =>
  axios.post(`${API}/rewards/check`, { address }).then((r) => r.data);
export const fetchVotes = () => axios.get(`${API}/votes`).then((r) => r.data);
export const castVote = (symbol, voter_id) =>
  axios.post(`${API}/votes`, { symbol, voter_id }).then((r) => r.data);
